module.exports = __webpack_public_path__ + "img/stock4.239c0a0c.png";